import { render } from "./DeletionRequest.vue?vue&type=template&id=30037486"
import script from "./DeletionRequest.vue?vue&type=script&lang=js"
export * from "./DeletionRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__